<script >

import bem from '@/utils/bem';

const b = bem('category-help-center-modal');

export default {
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    category: {
      type: Object,
      required: true,
    },
    onSubmit: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      isNew: true,
      title: '',
      mobileTitle: '',
    };
  },
  methods: {
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
    hideModal() {
      this.$emit('update:show', false);
      this.$emit('update:category', null);
      this.isNew = true;
      this.title = '';
      this.mobileTitle = '';
    },
    onSave() {
      this.onSubmit({
        ...(this.isNew ? {} : { categoryId: this.category.categoryId }),
        title: this.title,
        mobileTitle: this.mobileTitle,
      });
      this.hideModal();
    },
  },
  mounted() {
    this.isNew = !this.category;
    if (!this.isNew) {
      this.title = this.category.title || '';
      this.mobileTitle = this.category.mobileTitle || '';
    }
  },
  watch: {
    category: {
      handler(newValue) {
        this.isNew = !newValue?.categoryId;
        this.title = this.category?.title || '';
        this.mobileTitle = this.category?.mobileTitle || '';
      },
      deep: true,
    },
  },
};
</script>

<template>
  <a-modal
    :open="show"
    :footer="null"
    @cancel="hideModal"
    width="fit-content"
  >
    <div :class="b('')">
      <h1 :class="b('title')">{{ isNew ? 'Create new' : 'Edit' }} category help center</h1>
      <div :class="b('input-wrapper')">
        <span :class="b('input-title')">Name hint</span>
        <a-input
          :class="b('input')"
          type="text"
          placeholder="Enter name hint"
          v-model:value="title"
        />
      </div>
      <div :class="b('input-wrapper')">
        <span :class="b('input-title')">Mobile Name hint</span>
        <a-input
          :class="b('input')"
          type="text"
          placeholder="Enter mobile name hint"
          v-model:value="mobileTitle"
        />
      </div>
      <div :class="b('button')">
        <a-button
          type="primary"
          html-type="button"
          @click="onSave"
          size="large"
        >
          {{isNew ? "Add new category" : 'Edit category'}}
        </a-button>
      </div>
    </div>
  </a-modal>
</template>

<style scoped lang="scss">
  @import '@/styles/variables';
  @import "@/styles/media";
  @import "@/styles/fonts";

  .category-help-center-modal {
    display: flex;
    flex-direction: column;
    gap: 30px;
    min-width: 400px;

    @include mediaMinMax(1025, $normal) {
     min-width: vw-full(400);
      gap: vw-full(30);
    }

    &__title {
      padding: 0;
      margin: 0;
    }

    &__input-wrapper {
      display: flex;
      flex-direction: column;
      gap: 5px;
      max-width: 350px;

      @include mediaMinMax(1025, $normal) {
        gap: 5px;
        max-width: vw-full(350);
      }
    }

    &__input-title {
      font-size: 18px;
      font-weight: 500;

      @include mediaMinMax(1025, $normal) {
        font-size: vw-full(18);
      }
    }

    &__input {
      height: 45px;
      font-size: 16px;

      @include mediaMinMax(1025, $normal) {
        height: vw-full(45);
        font-size: vw-full(16);
      }
    }

    &__button {
      margin-left: auto;
      width: fit-content;
      font-size: 18px;

      @include mediaMinMax(1025, $normal) {
        font-size: vw-full(18);
      }
    }

  }
</style>
